import { useEffect } from "react";
import { NaeSSchemaMap } from "../../config/NaeSSchema";
import { useDataCache } from "./DataCacheProvider";
import { useSelector } from "react-redux";
import { SelectorTruckNae } from "../Models/ormSelectors";

interface ChildId {
  id: number
}

export interface ITruckModelNae {
    id: number,
scopes: any,
badges: any,

}

export const ITruckFieldsNae = [
    "id",
    "scopes",
    "badges"
];

export function useTruckHookNae(id: number) : ITruckModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorTruckNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.Truck.schema,
        fields: ITruckFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
